// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2gNZo","content":"styles_content__2x8Au","intro":"styles_intro__3qVaw"};